import React from "react";
import styles from "./Home.module.scss";
import { Banner, EarnedAmount, ReferStatus, ShareReferralCode } from "../../components";
import { Container } from "rsuite";

export default function Home() {
  return (
    <Container className={styles["home__styles"]}>
      <Banner />
      <EarnedAmount />
      <ShareReferralCode />
      <ReferStatus />
    </Container>
  );
}
